// extracted by mini-css-extract-plugin
export default {"cardGallerySkeleton":"skeleton_cardGallerySkeleton__BQr-Q","skeleton":"skeleton_skeleton__yilN8"};